import { useTenantSync } from '@/hooks/useTenantSync';

/**
 * Mounted once at the app root, inside the router, so the tenant plan / status
 * refresh runs for every authenticated page — including routes that live outside
 * the protected shells (onboarding, organization setup, profile setup). Renders
 * nothing.
 */
export default function TenantStatusSync() {
  useTenantSync();
  return null;
}
